import { render, staticRenderFns } from "./StartIcon.vue?vue&type=template&id=93d43d2c&"
import script from "./StartIcon.vue?vue&type=script&lang=js&"
export * from "./StartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports